// import React, { useEffect, useRef, useState } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { ArrowLeft, Calendar, Clock, Wifi, WifiOff } from "lucide-react";
// import Hls from "hls.js";
// import logo from "../../assets/Revibelogo.png";

// const API_BASE_URL =
//   process.env.REACT_APP_API_URL || "https://stage.getrevibe.app/api";

// /* ─── Stream Status Badge ────────────────────────────────────────────────── */
// const StatusBadge = ({ muxStatus }) => {
//   const isLive = muxStatus === "active";
//   const isIdle = muxStatus === "idle";

//   if (isIdle) {
//     return (
//       <span className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-700 text-xs font-bold px-3 py-1 rounded-full">
//         <WifiOff className="w-3 h-3" />
//         Not Started
//       </span>
//     );
//   }
// };

// /* ─── Helper to get playback ID from stream data ─────────────────────────── */
// const getPlaybackIdFromStream = (stream) => {
//   if (!stream) return null;

//   if (
//     stream.muxData?.playback_ids &&
//     Array.isArray(stream.muxData.playback_ids) &&
//     stream.muxData.playback_ids.length > 0
//   ) {
//     return stream.muxData.playback_ids[0].id;
//   }

//   if (
//     stream.playback_ids &&
//     Array.isArray(stream.playback_ids) &&
//     stream.playback_ids.length > 0
//   ) {
//     return stream.playback_ids[0].id;
//   }

//   if (stream.muxData?.id) {
//     return stream.muxData.id;
//   }

//   if (stream.muxData?.playbackId) {
//     return stream.muxData.playbackId;
//   }

//   if (stream.playbackId) {
//     return stream.playbackId;
//   }

//   return null;
// };

// /* ─── Video Player with Live Timer ───────────────────────────────────────── */
// const MuxPlayer = ({ playbackId, status, thumbnail, streamId }) => {
//   const videoRef = useRef(null);
//   const hlsRef = useRef(null);
//   const [playerError, setPlayerError] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const [retryCount, setRetryCount] = useState(0);
//   const [liveDuration, setLiveDuration] = useState(0);

//   const hlsUrl = `https://stream.mux.com/${playbackId}.m3u8`;
//   const isLive = status === "active";

//   // Timer for live duration
//   useEffect(() => {
//     let interval;
//     if (isLive && !playerError) {
//       interval = setInterval(() => {
//         setLiveDuration((prev) => prev + 1);
//       }, 1000);
//     } else {
//       setLiveDuration(0);
//     }
//     return () => {
//       if (interval) clearInterval(interval);
//     };
//   }, [isLive, playerError]);

//   const formatLiveDuration = () => {
//     const hours = Math.floor(liveDuration / 3600);
//     const minutes = Math.floor((liveDuration % 3600) / 60);
//     const seconds = liveDuration % 60;

//     if (hours > 0) {
//       return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
//     }
//     return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
//   };

//   useEffect(() => {
//     if (!playbackId) {
//       setIsLoading(false);
//       return;
//     }

//     // Not live yet — show "No Live Stream Active" with logo
//     if (!isLive) {
//       return (
//         <div className="relative w-full aspect-video bg-gray-900 rounded-2xl overflow-hidden flex items-center justify-center">
//           {thumbnail && (
//             <img
//               src={thumbnail}
//               alt="Stream thumbnail"
//               className="absolute inset-0 w-full h-full object-cover opacity-40"
//             />
//           )}
//           <div className="relative z-10 flex flex-col items-center gap-4 px-6 text-center">
//             <img src={logo} alt="Revibe" className="h-12 w-auto opacity-80" />
//             <div className="w-14 h-14 rounded-full bg-white/10 backdrop-blur flex items-center justify-center">
//               <WifiOff className="w-7 h-7 text-white/70" />
//             </div>
//             <p className="text-white font-semibold text-base">
//               No Live Stream Active
//             </p>
//             <p className="text-white/50 text-sm">
//               Come back at the scheduled time to watch live.
//             </p>
//           </div>
//         </div>
//       );
//     }

//     const video = videoRef.current;
//     if (!video) return;

//     setPlayerError(false);
//     setIsLoading(true);

//     if (hlsRef.current) {
//       hlsRef.current.destroy();
//       hlsRef.current = null;
//     }

//     if (Hls.isSupported()) {
//       const hls = new Hls({
//         lowLatencyMode: true,
//         enableWorker: true,
//         liveSyncDurationCount: 3,
//         maxLoadingDelay: 4,
//         defaultAudioCodec: "mp4a.40.2",
//       });
//       hlsRef.current = hls;

//       hls.on(Hls.Events.MANIFEST_PARSED, () => {
//         setIsLoading(false);
//         video.play().catch(() => {});
//       });

//       hls.on(Hls.Events.ERROR, (_, data) => {
//         if (data.fatal) {
//           switch (data.type) {
//             case Hls.ErrorTypes.NETWORK_ERROR:
//               hls.startLoad();
//               break;
//             case Hls.ErrorTypes.MEDIA_ERROR:
//               hls.recoverMediaError();
//               break;
//             default:
//               if (retryCount < 3) {
//                 setRetryCount((prev) => prev + 1);
//                 setTimeout(() => {
//                   hls.loadSource(hlsUrl);
//                 }, 2000);
//               } else {
//                 setPlayerError(true);
//                 setIsLoading(false);
//               }
//               break;
//           }
//         }
//       });

//       hls.loadSource(hlsUrl);
//       hls.attachMedia(video);
//     } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
//       video.src = hlsUrl;
//       video.addEventListener("loadedmetadata", () => {
//         setIsLoading(false);
//         video.play().catch(() => {});
//       });
//       video.addEventListener("error", () => {
//         setPlayerError(true);
//         setIsLoading(false);
//       });
//     } else {
//       setPlayerError(true);
//       setIsLoading(false);
//     }

//     return () => {
//       if (hlsRef.current) {
//         hlsRef.current.destroy();
//         hlsRef.current = null;
//       }
//     };
//   }, [playbackId, isLive, hlsUrl, retryCount]);

//   // Not live yet — show "No Live Stream Active" with logo

//   if (playerError) {
//     return (
//       <div className="w-full aspect-video bg-gray-900 rounded-2xl flex items-center justify-center">
//         <div className="flex flex-col items-center gap-2 text-center px-6">
//           <WifiOff className="w-8 h-8 text-red-400" />
//           <p className="text-white font-semibold">Unable to load stream</p>
//           <p className="text-white/50 text-sm">
//             The stream may have ended or is temporarily unavailable.
//           </p>
//           <button
//             onClick={() => {
//               setRetryCount(0);
//               setPlayerError(false);
//             }}
//             className="mt-4 px-4 py-2 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 transition-colors"
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="relative w-full aspect-video bg-black rounded-2xl overflow-hidden">
//       {isLoading && (
//         <div className="absolute inset-0 flex items-center justify-center bg-black/80 z-10">
//           <div className="flex flex-col items-center gap-3">
//             <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
//             <span className="text-white/60 text-sm">Loading stream...</span>
//           </div>
//         </div>
//       )}
//       <video
//         ref={videoRef}
//         className="w-full h-full object-contain"
//         controls
//         playsInline
//         autoPlay
//       />
//     </div>
//   );
// };

// /* ─── Skeleton Loader ────────────────────────────────────────────────────── */
// const PageSkeleton = () => (
//   <div className="min-h-screen bg-white px-5 pt-4 pb-10 animate-pulse">
//     <div className="w-8 h-8 rounded-full bg-gray-200 mb-5" />
//     <div className="w-full aspect-video rounded-2xl bg-gray-200 mb-6" />
//     <div className="flex gap-2 mb-4">
//       <div className="h-6 bg-gray-200 rounded-full w-16" />
//     </div>
//     <div className="h-7 bg-gray-200 rounded w-3/4 mb-3" />
//     <div className="h-4 bg-gray-200 rounded w-1/2 mb-1" />
//     <div className="h-4 bg-gray-200 rounded w-2/5 mb-6" />
//     <div className="h-32 bg-gray-200 rounded-2xl" />
//   </div>
// );

// /* ─── Main Page ──────────────────────────────────────────────────────────── */
// const MuxStreamPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [stream, setStream] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!id) return;

//     const fetchStream = async () => {
//       setIsLoading(true);
//       setError(null);

//       try {
//         const token = localStorage.getItem("authToken");

//         const response = await fetch(`${API_BASE_URL}/mux/${id}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           if (response.status === 404) {
//             throw new Error("Stream not found");
//           }
//           throw new Error("Failed to load stream");
//         }

//         const data = await response.json();
//         setStream(data);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     if (location.state?.eventData) {
//       setStream(location.state.eventData);
//       setIsLoading(false);
//     } else {
//       fetchStream();
//     }
//   }, [id, location.state]);

//   const formatDate = (dateString) => {
//     if (!dateString) return "—";
//     try {
//       return new Date(dateString).toLocaleDateString("en-US", {
//         weekday: "short",
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       });
//     } catch {
//       return "—";
//     }
//   };

//   const formatTime = (dateString) => {
//     if (!dateString) return "—";
//     try {
//       return new Date(dateString).toLocaleTimeString("en-US", {
//         hour: "2-digit",
//         minute: "2-digit",
//         hour12: true,
//       });
//     } catch {
//       return "—";
//     }
//   };

//   if (isLoading) return <PageSkeleton />;

//   if (error || !stream) {
//     return (
//       <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 gap-4">
//         <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center">
//           <WifiOff className="w-7 h-7 text-red-400" />
//         </div>
//         <p className="text-gray-800 font-semibold text-lg text-center">
//           {error || "Stream not found"}
//         </p>
//         <button
//           onClick={() => navigate(-1)}
//           className="text-green-600 font-medium text-sm hover:text-green-700 transition-colors"
//         >
//           Go Back
//         </button>
//       </div>
//     );
//   }

//   const scheduledAt =
//     stream.sheduled_at ||
//     stream.scheduled_at ||
//     stream.date ||
//     stream.createdAt;
//   const muxStatus =
//     stream.status === "Active"
//       ? "active"
//       : stream.muxData?.status || stream.status || "idle";
//   const playbackId = getPlaybackIdFromStream(stream);
//   const thumbnail = stream.img || stream.thumbnail;

//   if (!playbackId) {
//     return (
//       <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 gap-4">
//         <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center">
//           <WifiOff className="w-7 h-7 text-red-400" />
//         </div>
//         <p className="text-gray-800 font-semibold text-lg text-center">
//           Stream configuration error
//         </p>
//         <p className="text-gray-500 text-sm text-center">
//           Unable to load stream. Please try again later.
//         </p>
//         <button
//           onClick={() => navigate(-1)}
//           className="text-green-600 font-medium text-sm hover:text-green-700 transition-colors"
//         >
//           Go Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-white pb-12">
//       {/* Top bar */}
//       <div className="flex items-center gap-3 px-5 pt-5 pb-3">
//         <button
//           onClick={() => navigate(-1)}
//           className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
//           aria-label="Go back"
//         >
//           <ArrowLeft className="w-4 h-4 text-gray-700" />
//         </button>
//         <h1 className="text-base font-semibold text-gray-900 truncate flex-1">
//           Live Session
//         </h1>
//       </div>

//       <div className="px-5 flex flex-col gap-5">
//         {/* Player */}
//         <MuxPlayer
//           playbackId={playbackId}
//           status={muxStatus}
//           thumbnail={thumbnail}
//           streamId={stream._id}
//         />

//         {/* Status + title */}
//         <div className="flex flex-col gap-2">
//           <StatusBadge muxStatus={muxStatus} />

//           {stream.title && (
//             <h2 className="text-gray-900 text-xl font-bold leading-snug">
//               {stream.title}
//             </h2>
//           )}

//           {stream.subtitle && (
//             <p className="text-gray-500 text-sm">{stream.subtitle}</p>
//           )}
//         </div>

//         {/* Meta info */}
//         <div className="flex flex-col gap-2.5 bg-gray-50 rounded-2xl p-4 border border-gray-100">
//           <div className="flex items-center gap-3">
//             <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0">
//               <Calendar className="w-4 h-4 text-green-600" />
//             </div>
//             <div>
//               <p className="text-xs text-gray-400 font-medium">
//                 Scheduled Date
//               </p>
//               <p className="text-sm text-gray-800 font-semibold">
//                 {formatDate(scheduledAt)}
//               </p>
//             </div>
//           </div>

//           <div className="border-t border-gray-100" />

//           <div className="flex items-center gap-3">
//             <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0">
//               <Clock className="w-4 h-4 text-green-600" />
//             </div>
//             <div>
//               <p className="text-xs text-gray-400 font-medium">Start Time</p>
//               <p className="text-sm text-gray-800 font-semibold">
//                 {formatTime(scheduledAt)}
//               </p>
//             </div>
//           </div>

//           {stream.description && (
//             <>
//               <div className="border-t border-gray-100" />
//               <p className="text-sm text-gray-500 leading-relaxed pt-1">
//                 {stream.description}
//               </p>
//             </>
//           )}
//         </div>

//         {/* Tags */}
//         {stream.tags?.length > 0 && (
//           <div className="flex flex-wrap gap-2">
//             {stream.tags.map((tag, i) => (
//               <span
//                 key={i}
//                 className="bg-green-50 text-green-700 text-xs font-medium px-3 py-1 rounded-full border border-green-100"
//               >
//                 {tag}
//               </span>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default MuxStreamPage;
import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, Calendar, Clock, WifiOff } from "lucide-react";
import Hls from "hls.js";
import logo from "../../assets/Revibelogo.png";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://stage.getrevibe.app/api";

/* ─── Stream Status Badge ────────────────────────────────────────────────── */
const StatusBadge = ({ muxStatus }) => {
  if (muxStatus === "active") {
    return (
      <span className="inline-flex items-center gap-1.5 bg-red-100 text-red-600 text-xs font-bold px-3 py-1 rounded-full">
        <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
        LIVE
      </span>
    );
  }

  if (muxStatus === "idle") {
    return (
      <span className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-700 text-xs font-bold px-3 py-1 rounded-full">
        <WifiOff className="w-3 h-3" />
        Not Started
      </span>
    );
  }

  return null;
};

/* ─── Helper to get playback ID from stream data ─────────────────────────── */
const getPlaybackIdFromStream = (stream) => {
  if (!stream) return null;

  if (
    stream.muxData?.playback_ids &&
    Array.isArray(stream.muxData.playback_ids) &&
    stream.muxData.playback_ids.length > 0
  ) {
    return stream.muxData.playback_ids[0].id;
  }

  if (
    stream.playback_ids &&
    Array.isArray(stream.playback_ids) &&
    stream.playback_ids.length > 0
  ) {
    return stream.playback_ids[0].id;
  }

  if (stream.muxData?.playbackId) return stream.muxData.playbackId;
  if (stream.playbackId) return stream.playbackId;

  return null;
};

/* ─── Helper to get Mux Status from stream data ─────────────────────────── */
const getMuxStatus = (stream) => {
  if (!stream) return "idle";

  // Debug logging
  console.log("Getting Mux Status from stream:", {
    directStatus: stream.status,
    muxDataStatus: stream.muxData?.status,
    muxDataMuxStatus: stream.muxData?.mux_status,
    muxStatusField: stream.mux_status,
    fullMuxData: stream.muxData,
  });

  // Direct status from stream
  if (stream.status) {
    const status = String(stream.status).toLowerCase();
    if (status === "active") return "active";
    if (status === "idle") return "idle";
  }

  // From muxData.status
  if (stream.muxData?.status) {
    const status = String(stream.muxData.status).toLowerCase();
    if (status === "active") return "active";
    if (status === "idle") return "idle";
  }

  // From muxData.mux_status
  if (stream.muxData?.mux_status) {
    const status = String(stream.muxData.mux_status).toLowerCase();
    if (status === "active") return "active";
    if (status === "idle") return "idle";
  }

  // From direct mux_status field
  if (stream.mux_status) {
    const status = String(stream.mux_status).toLowerCase();
    if (status === "active") return "active";
    if (status === "idle") return "idle";
  }

  // If stream has playbackId but no status, assume it might be active
  if (getPlaybackIdFromStream(stream)) {
    console.log("Stream has playbackId but no status, defaulting to 'active'");
    return "active";
  }

  // Default to idle
  return "idle";
};

/* ─── Video Player ───────────────────────────────────────────────────────── */
const MuxPlayer = ({ playbackId, muxStatus, thumbnail }) => {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);
  const [playerError, setPlayerError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [retryCount, setRetryCount] = useState(0);
  const [liveDuration, setLiveDuration] = useState(0);

  // isLive is determined ONLY by muxData.status
  const isLive = muxStatus === "active";
  const hlsUrl = `https://stream.mux.com/${playbackId}.m3u8`;

  console.log("MuxPlayer rendering:", { playbackId, muxStatus, isLive });

  // Live duration timer
  useEffect(() => {
    let interval;
    if (isLive && !playerError) {
      interval = setInterval(() => setLiveDuration((p) => p + 1), 1000);
    } else {
      setLiveDuration(0);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isLive, playerError]);

  const formatLiveDuration = () => {
    const h = Math.floor(liveDuration / 3600);
    const m = Math.floor((liveDuration % 3600) / 60);
    const s = liveDuration % 60;
    if (h > 0) {
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    }
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  // HLS setup — only when live
  useEffect(() => {
    if (!playbackId || !isLive) {
      setIsLoading(false);
      return;
    }

    const video = videoRef.current;
    if (!video) return;

    setPlayerError(false);
    setIsLoading(true);

    if (hlsRef.current) {
      hlsRef.current.destroy();
      hlsRef.current = null;
    }

    if (Hls.isSupported()) {
      const hls = new Hls({
        lowLatencyMode: true,
        enableWorker: true,
        liveSyncDurationCount: 3,
        maxLoadingDelay: 4,
        defaultAudioCodec: "mp4a.40.2",
      });
      hlsRef.current = hls;

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        setIsLoading(false);
        video.play().catch((err) => console.log("Auto-play prevented:", err));
      });

      hls.on(Hls.Events.ERROR, (_, data) => {
        console.log("HLS Error:", data);
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.log("Network error, trying to recover...");
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.log("Media error, trying to recover...");
              hls.recoverMediaError();
              break;
            default:
              if (retryCount < 3) {
                console.log(`Retrying... (${retryCount + 1}/3)`);
                setRetryCount((p) => p + 1);
                setTimeout(() => hls.loadSource(hlsUrl), 2000);
              } else {
                console.log("Max retries reached, showing error");
                setPlayerError(true);
                setIsLoading(false);
              }
          }
        }
      });

      hls.loadSource(hlsUrl);
      hls.attachMedia(video);
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = hlsUrl;
      video.addEventListener("loadedmetadata", () => {
        setIsLoading(false);
        video.play().catch((err) => console.log("Auto-play prevented:", err));
      });
      video.addEventListener("error", () => {
        setPlayerError(true);
        setIsLoading(false);
      });
    } else {
      setPlayerError(true);
      setIsLoading(false);
    }

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
    };
  }, [playbackId, isLive, hlsUrl, retryCount]);

  // ── Not live — show offline placeholder ──
  if (!isLive) {
    return (
      <div className="relative w-full aspect-video bg-gray-900 rounded-2xl overflow-hidden flex items-center justify-center">
        {thumbnail && (
          <img
            src={thumbnail}
            alt="Stream thumbnail"
            className="absolute inset-0 w-full h-full object-cover opacity-40"
          />
        )}
        <div className="relative z-10 flex flex-col items-center gap-4 px-6 text-center">
          <img src={logo} alt="Revibe" className="h-12 w-auto opacity-80" />
          <div className="w-14 h-14 rounded-full bg-white/10 backdrop-blur flex items-center justify-center">
            <WifiOff className="w-7 h-7 text-white/70" />
          </div>
          <p className="text-white font-semibold text-base">
            No Live Stream Active
          </p>
          <p className="text-white/50 text-sm">
            Come back at the scheduled time to watch live.
          </p>
        </div>
      </div>
    );
  }

  // ── Player error ──
  if (playerError) {
    return (
      <div className="w-full aspect-video bg-gray-900 rounded-2xl flex items-center justify-center">
        <div className="flex flex-col items-center gap-2 text-center px-6">
          <WifiOff className="w-8 h-8 text-red-400" />
          <p className="text-white font-semibold">Unable to load stream</p>
          <p className="text-white/50 text-sm">
            The stream may have ended or is temporarily unavailable.
          </p>
          <button
            onClick={() => {
              setRetryCount(0);
              setPlayerError(false);
            }}
            className="mt-4 px-4 py-2 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // ── Live player ──
  return (
    <div className="relative w-full aspect-video bg-black rounded-2xl overflow-hidden">
      {/* LIVE badge + timer — top-right corner */}
      {!isLoading && (
        <div className="absolute top-3 left-3 z-20 flex items-center gap-2 pointer-events-none">
          <span className="flex items-center gap-1.5 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
            LIVE
          </span>
          <span className="bg-black/60 backdrop-blur-sm text-white text-xs font-semibold px-2.5 py-1 rounded-full">
            {formatLiveDuration()}
          </span>
        </div>
      )}

      {/* Loading spinner */}
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/80 z-10">
          <div className="flex flex-col items-center gap-3">
            <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
            <span className="text-white/60 text-sm">Loading stream...</span>
          </div>
        </div>
      )}

      <video
        ref={videoRef}
        className="w-full h-full object-contain"
        controls
        playsInline
        autoPlay
      />
    </div>
  );
};

/* ─── Skeleton Loader ────────────────────────────────────────────────────── */
const PageSkeleton = () => (
  <div className="min-h-screen bg-white px-5 pt-4 pb-10 animate-pulse">
    <div className="w-8 h-8 rounded-full bg-gray-200 mb-5" />
    <div className="w-full aspect-video rounded-2xl bg-gray-200 mb-6" />
    <div className="flex gap-2 mb-4">
      <div className="h-6 bg-gray-200 rounded-full w-16" />
    </div>
    <div className="h-7 bg-gray-200 rounded w-3/4 mb-3" />
    <div className="h-4 bg-gray-200 rounded w-1/2 mb-1" />
    <div className="h-4 bg-gray-200 rounded w-2/5 mb-6" />
    <div className="h-32 bg-gray-200 rounded-2xl" />
  </div>
);

/* ─── Main Page ──────────────────────────────────────────────────────────── */
const MuxStreamPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [stream, setStream] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [muxStatus, setMuxStatus] = useState("idle");

  useEffect(() => {
    if (!id) return;

    const fetchStream = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem("authToken");
        const response = await fetch(`${API_BASE_URL}/mux/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) {
          throw new Error(
            response.status === 404
              ? "Stream not found"
              : "Failed to load stream",
          );
        }
        const data = await response.json();

        console.log("=== Full API Response ===");
        console.log("Stream data:", data);
        console.log("Status fields:", {
          directStatus: data.status,
          muxDataStatus: data.muxData?.status,
          muxData: data.muxData,
        });

        setStream(data);

        // Set initial mux status
        const status = getMuxStatus(data);
        console.log("Detected muxStatus:", status);
        setMuxStatus(status);

        // If stream is live, poll for status updates every 10 seconds
        if (status === "active") {
          const interval = setInterval(async () => {
            try {
              const token = localStorage.getItem("authToken");
              const refreshResponse = await fetch(`${API_BASE_URL}/mux/${id}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              });
              if (refreshResponse.ok) {
                const refreshedData = await refreshResponse.json();
                const newStatus = getMuxStatus(refreshedData);
                setMuxStatus(newStatus);
                setStream(refreshedData);
              }
            } catch (err) {
              console.log("Failed to refresh stream status:", err);
            }
          }, 10000);

          return () => clearInterval(interval);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    if (location.state?.eventData) {
      const eventData = location.state.eventData;
      console.log("Using event data from location.state:", eventData);
      setStream(eventData);
      const status = getMuxStatus(eventData);
      console.log("Detected muxStatus from eventData:", status);
      setMuxStatus(status);
      setIsLoading(false);
    } else {
      fetchStream();
    }
  }, [id, location.state]);

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    try {
      return new Date(dateString).toLocaleDateString("en-US", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return "—";
    }
  };

  const formatTime = (dateString) => {
    if (!dateString) return "—";
    try {
      return new Date(dateString).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch {
      return "—";
    }
  };

  if (isLoading) return <PageSkeleton />;

  if (error || !stream) {
    return (
      <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 gap-4">
        <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center">
          <WifiOff className="w-7 h-7 text-red-400" />
        </div>
        <p className="text-gray-800 font-semibold text-lg text-center">
          {error || "Stream not found"}
        </p>
        <button
          onClick={() => navigate(-1)}
          className="text-green-600 font-medium text-sm hover:text-green-700 transition-colors"
        >
          Go Back
        </button>
      </div>
    );
  }

  const scheduledAt =
    stream.sheduled_at ||
    stream.scheduled_at ||
    stream.date ||
    stream.createdAt;
  const thumbnail = stream.img || stream.thumbnail;
  const playbackId = getPlaybackIdFromStream(stream);

  if (!playbackId) {
    return (
      <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 gap-4">
        <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center">
          <WifiOff className="w-7 h-7 text-red-400" />
        </div>
        <p className="text-gray-800 font-semibold text-lg text-center">
          Stream configuration error
        </p>
        <p className="text-gray-500 text-sm text-center">
          Unable to load stream. Please try again later.
        </p>
        <button
          onClick={() => navigate(-1)}
          className="text-green-600 font-medium text-sm hover:text-green-700 transition-colors"
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pb-12">
      {/* Top bar */}
      <div className="flex items-center gap-3 px-5 pt-5 pb-3">
        <button
          onClick={() => navigate(-1)}
          className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
          aria-label="Go back"
        >
          <ArrowLeft className="w-4 h-4 text-gray-700" />
        </button>
        <h1 className="text-base font-semibold text-gray-900 truncate flex-1">
          Live Session
        </h1>
      </div>

      <div className="px-5 flex flex-col gap-5">
        {/* Player */}
        <MuxPlayer
          playbackId={playbackId}
          muxStatus={muxStatus}
          thumbnail={thumbnail}
        />

        {/* Status + title */}
        <div className="flex flex-col gap-2">
          {stream.title && (
            <h2 className="text-gray-900 text-xl font-bold leading-snug">
              {stream.title}
            </h2>
          )}

          {stream.subtitle && (
            <p className="text-gray-500 text-sm">{stream.subtitle}</p>
          )}
        </div>

        {/* Meta info */}
        <div className="flex flex-col gap-2.5 bg-gray-50 rounded-2xl p-4 border border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0">
              <Calendar className="w-4 h-4 text-green-600" />
            </div>
            <div>
              <p className="text-xs text-gray-400 font-medium">
                Scheduled Date
              </p>
              <p className="text-sm text-gray-800 font-semibold">
                {formatDate(scheduledAt)}
              </p>
            </div>
          </div>

          <div className="border-t border-gray-100" />

          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0">
              <Clock className="w-4 h-4 text-green-600" />
            </div>
            <div>
              <p className="text-xs text-gray-400 font-medium">Start Time</p>
              <p className="text-sm text-gray-800 font-semibold">
                {formatTime(scheduledAt)}
              </p>
            </div>
          </div>

          {stream.description && (
            <>
              <div className="border-t border-gray-100" />
              <p className="text-sm text-gray-500 leading-relaxed pt-1">
                {stream.description}
              </p>
            </>
          )}
        </div>

        {/* Tags */}
        {stream.tags?.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {stream.tags.map((tag, i) => (
              <span
                key={i}
                className="bg-green-50 text-green-700 text-xs font-medium px-3 py-1 rounded-full border border-green-100"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MuxStreamPage;
